import React, { useState, useEffect } from "react";
import "./ViewReportsCEOTable.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faTrash,
  faEdit,
  faEye,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";
import { Form, Button, Col, Row } from "react-bootstrap";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import ViewModal from "./ViewModal";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;

export default function ViewReportsCEOTable(props) {
  const [ViewReportsCEOData, setViewReportsCEOData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchData, setSearchData] = useState("");
  const [rowData, setRowData] = useState([]);
  const [SelectRepo, setSelectRepo] = useState(null);
  const [modalShow, setModalShow] = useState(false);

  const ViewReport = (report) => {
    setSelectRepo(report);
    setModalShow(true);
  };
  const renderViewButton = (params) => {
    // console.log(params);
    if (props.back) {
      return <React.Fragment />;
    }
    return (
      <Button
        variant="light"
        style={{ backgroundColor: "none" }}
        onClick={() => ViewReport(params.data.data)}>
        <FontAwesomeIcon icon={faEye} /> &nbsp;&nbsp; View
      </Button>
    );
  };
  const DownloadLink = (link) => {
    window.open("https://almawridems.javedahmadghamidi.com/" + link);
  };
  const renderDownloadButton = (params) => {
    // console.log(params);
    if (props.back) {
      return <React.Fragment />;
    }
    return (
      params.data.data.FileLinks !== "" && (
        <Button
          variant="light"
          style={{ backgroundColor: "none" }}
          onClick={() => DownloadLink(params.data.data.FileLinks)}>
          <FontAwesomeIcon icon={faDownload} />
          &nbsp;&nbsp;Attachment
        </Button>
      )
    );
  };

  const columnDefs = [
    {
      headerName: "View Report",
      field: "view",
      filter: false,
      width: 120,
      cellRendererFramework: renderViewButton,
    },
    {
      headerName: "Attachment",
      field: "FileLinks",
      sortable: true,
      cellRendererFramework: renderDownloadButton,
      width: 150,
      // filter: true ,
    },
    {
      headerName: "Month & Year",
      field: "monthyear",
      sortable: true,
      width: 140,
      // filter: true ,
    },
    {
      headerName: "Modifed on",
      field: "EditDate",
      sortable: true,
      width: 200,
      // filter: true ,
    },
  ];

  const defaultColDef = {
    resizable: true,
    width: 170,
    filter: "agTextColumnFilter",
    // filter: true ,
  };
  const getRowHeight = 45;

  const loadViewReportsCEOData = () => {
    axios
      .get(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-data-ceo/" +
          localStorage.getItem("department"),
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((response) => {
        setViewReportsCEOData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onViewReportsCEODelete = (e1, e2) => {
    // console.log(e1, e2);
    if (window.confirm("Are you sure to delete this record? ") === true) {
      axios
        .delete(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/leave-application-ceo/" +
            e1 +
            "/" +
            e2,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          loadViewReportsCEOData();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  useEffect(() => {
    loadViewReportsCEOData();
  }, []);
  const SelectedEmp = (e) => {
    ViewReportsCEOData.forEach((data) => {
      if (data._id == e) {
        let rowDataT = [];

        // let data=this.educationObj.education["0"];
        data["monthlyreport"].map((data) => {
          let temp = {
            data,
            monthyear: data.monthyear,
            EditDate: data.EditDate.split(" ")
              .slice(0, 5)
              .join(" ")
              .split(":")
              .slice(0, 2)
              .join(":"),
            Text: data.Text,
          };
          rowDataT.push(temp);
        });
        setRowData(rowDataT);
      }
    });
  };

  return (
    <div id="table-outer-div-scroll">
      <h2 id="role-title">Employee Monthly Report Details</h2>
      <Form.Group as={Row} className="mr-md-2 ml-md-2">
        <Form.Label column sm={8}>
          Click Employee's Name
        </Form.Label>
      </Form.Group>

      {ViewReportsCEOData.map(
        (data, index) =>
          data["monthlyreport"].length > 0 && (
            <Button
              style={{ margin: "10px" }}
              key={index}
              onClick={() => SelectedEmp(data["_id"])}>
              {data["FirstName"] + " " + data["LastName"]}
            </Button>
          )
      )}

      <div id="clear-both" />
      {!loading ? (
        <div id="table-div" className="ag-theme-balham">
          {rowData.length > 0 && (
            <AgGridReact
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              rowData={rowData}
              pagination={true}
              paginationPageSize={10}
              getRowHeight={getRowHeight}
            />
          )}
        </div>
      ) : (
        <div id="loading-bar">
          <RingLoader
            css={override}
            sizeUnit={"px"}
            size={50}
            color={"#0000ff"}
            loading={true}
          />
        </div>
      )}
      {SelectRepo && (
        <ViewModal
          show={modalShow}
          onHide={() => {
            setModalShow(false);
            setSelectRepo(null);
          }}
          SelectRepo={SelectRepo}
        />
      )}
    </div>
  );
}
